module.exports = __webpack_public_path__ + "static/img/7.d6bbdba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/meizu/7.png
// module id = TWqp
// module chunks = 0